import { Component, EventEmitter, Output, inject } from '@angular/core';
import {
  I18nService,
  AVAILABLE_LANGUAGES,
  LanguageType,
} from '../../shared/i18n/i18n.service';
import { DropdownMenuComponent } from './dropdown-menu/dropdown-menu-component';
import { ProjectService } from '../../shared/services/project/project.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-topbar',
  imports: [DropdownMenuComponent],
  templateUrl: './topbar.html',
  styleUrl: './topbar.scss',
})
export class Topbar {
  @Output() menuToggle = new EventEmitter<void>();

  protected readonly projectService = inject(ProjectService);
  protected readonly i18n = inject(I18nService);
  protected readonly lang = this.i18n.lang;
  protected readonly AVAILABLE_LANGUAGES = AVAILABLE_LANGUAGES;
  protected readonly router = inject(Router);

  setLanguage(lang: LanguageType): void {
    this.i18n.lang.set(lang);
  }

  navigateToHome() {
    this.router.navigate(['/plants']);
  }
}
